import { render, staticRenderFns } from "./CadastroLaudoDistribuicao.vue?vue&type=template&id=6bc9c664&"
import script from "./CadastroLaudoDistribuicao.vue?vue&type=script&lang=js&"
export * from "./CadastroLaudoDistribuicao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports